<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: "blog",
};
</script>

<style>
</style>